var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "10px 0px 20px" } },
    [
      _vm.visible
        ? _c(
            "el-upload",
            {
              attrs: {
                action: _vm.importUrl,
                headers: _vm.headers,
                "before-upload": _vm.beforeAvatarUpload,
                "before-remove": _vm.beforeRemove,
                "on-success": _vm.handleAvatarSuccess,
                "on-remove": _vm.handleRemove,
                "file-list": _vm.currentValue,
                "on-error": _vm.uploadError,
                disabled: _vm.isAbled,
                "on-progress": _vm.progressing
              }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "primary" } }, [
                _vm._v("导入附件")
              ]),
              _vm._v(" "),
              !_vm.type
                ? _c(
                    "div",
                    {
                      staticClass: "el-upload__tip",
                      attrs: { slot: "tip" },
                      slot: "tip"
                    },
                    [
                      _c(
                        "strong",
                        {
                          staticStyle: {
                            "margin-right": "5px",
                            "line-height": "20px"
                          }
                        },
                        [_vm._v("附件说明：")]
                      ),
                      _vm._v(
                        "导入附件，该功能主要支持三天下的操作页面上的附件文件导入上传功能，实现从教学平台获取附件导入三天下效果。目前不支持仿真政务等其他导入功能。\n    "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a03a914", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a03a914","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v_addFile.vue
// module id = null
// module chunks = 